import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import {
  HTTP_INTERCEPTORS,
  HttpClientModule,
  HttpClient,
} from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ToastrModule } from 'ngx-toastr';
import { ChartModule } from 'primeng-lts/chart';
import { SkeletonModule } from 'primeng-lts/skeleton';
import { ColorPickerModule } from 'primeng-lts/colorpicker';
import { SplitButtonModule } from 'primeng-lts/splitbutton';

import { TabViewModule } from 'primeng-lts/tabview';
import { AuthInterceptor } from './vehicles/services/auth.interceptor';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { AgGridModule } from 'ag-grid-angular';
import { AutoCompleteModule } from 'primeng-lts/autocomplete';
import { TreeTableModule } from 'primeng-lts/treetable';
import { TreeModule } from 'primeng-lts/tree';
import { DialogModule } from 'primeng-lts/dialog';

import { DropdownModule } from 'primeng-lts/dropdown';
import { InputMaskModule } from 'primeng-lts/inputmask';
import { InputTextModule } from 'primeng-lts/inputtext';
import { InputNumberModule } from 'primeng-lts/inputnumber';
import { ConfirmDialogModule } from 'primeng-lts/confirmdialog';
import { ConfirmationService } from 'primeng-lts/api';
import { SelectButtonModule } from 'primeng-lts/selectbutton';
import { RatingModule } from 'primeng-lts/rating';
import { RadioButtonModule } from 'primeng-lts/radiobutton';
import { PickListModule } from 'primeng-lts/picklist';
import { ListboxModule } from 'primeng-lts/listbox';
import { CardModule } from 'primeng-lts/card';
import { CheckboxModule } from 'primeng-lts/checkbox';
import { MultiSelectModule } from 'primeng-lts/multiselect';
import { CalendarModule } from 'primeng-lts/calendar';
import { ToggleButtonModule } from 'primeng-lts/togglebutton';
import { InputSwitchModule } from 'primeng-lts/inputswitch';
import { TableModule } from 'primeng-lts/table';
import { PanelModule } from 'primeng-lts/panel';
import { BadgeModule } from 'primeng-lts/badge';
import { SliderModule } from 'primeng-lts/slider';
import { OverlayPanelModule } from 'primeng-lts/overlaypanel';
import { TagModule } from 'primeng-lts/tag';
import { TooltipModule } from 'primeng-lts/tooltip';
import { SlideMenuModule } from 'primeng-lts/slidemenu';
import { ProgressBarModule } from 'primeng-lts/progressbar';
import { MenuModule } from 'primeng-lts/menu';
import { SidebarModule } from 'primeng-lts/sidebar';
import { ScrollPanelModule } from 'primeng-lts/scrollpanel';
import { GalleriaModule } from 'primeng-lts/galleria';
import { ProgressSpinnerModule } from 'primeng-lts/progressspinner';
import { ContextMenuModule } from 'primeng-lts/contextmenu';

// import { LeafletMarkerClusterModule } from '../../../leaflet-markercluster/leaflet-markercluster.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule } from '@angular/router';
import { CarouselModule } from 'primeng-lts/carousel';
// import { LeafletModule } from '@asymmetrik/ngx-leaflet';
import { LeafletModule } from '@asymmetrik/ngx-leaflet';
import { LeafletMarkerClusterModule } from '@asymmetrik/ngx-leaflet-markercluster';

import { NgxsModule } from '@ngxs/store';
import { NgxsStoragePluginModule } from '@ngxs/storage-plugin';
import { NgxSpinnerModule } from 'ngx-spinner';

import { AuthState } from './core/store/auth.state';
import { ErrorInterceptor } from './core/interceptors/error.interceptor';
import { TokenInterceptor } from './core/interceptors/token.interceptor';
import { NavbarComponent } from './panel/components/navbar/navbar.component';
import { SidebarComponent } from './panel/components/sidebar/sidebar.component';
import { MapareaComponent } from './panel/components/maparea/maparea.component';
import { PanelConfComponent } from './panel/components/panel-conf/panel-conf.component';
import { VehiclesComponent } from './vehicles/components/vehicles/vehicles.component';
import { VehicleComponent } from './vehicles/components/vehicle/vehicle.component';
import { SessionComponent } from './vehicles/components/session/session.component';
import { MapComponent } from './vehicles/components/map/map.component';
import { PanelHistorialComponent } from './historial/components/panel-historial/panel-historial.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PanelMonitoreoComponent } from './panel/components/panel-monitoreo/panel-monitoreo.component';
import { PanelGeopointsComponent } from './geopoints/components/panel-geopoints/panel-geopoints.component';
import { PanelVehiclesComponent } from './vehicles/components/panel-vehicles/panel-vehicles.component';
import { EyeHeaderComponent } from './vehicles/components/eye-header/eye-header.component';
import { LimitHeaderComponent } from './vehicles/components/limit-header/limit-header.component';
import { FollowHeaderComponent } from './vehicles/components/follow-header/follow-header.component';
import { TransmissionHeaderComponent } from './vehicles/components/transmission-header/transmission-header.component';
import { TagHeaderComponent } from './vehicles/components/tag-header/tag-header.component';
import { TagDriverComponent } from './vehicles/components/tag-driver/tag-driver.component';
import { TagDriverHeaderComponent } from './vehicles/components/tag-driver-header/tag-driver-header.component';
import { SettingHeaderComponent } from './vehicles/components/setting-header/setting-header.component';
import { EyeComponent } from './vehicles/components/eye/eye.component';
import { GpsHeaderComponent } from './vehicles/components/gps-header/gps-header.component';
import { GsmHeaderComponent } from './vehicles/components/gsm-header/gsm-header.component';
import { MapViewComponent } from './map/components/map-view/map-view.component';
import { TransmissionComponent } from './vehicles/components/transmission/transmission.component';
import { GpsComponent } from './vehicles/components/gps/gps.component';
import { GsmComponent } from './vehicles/components/gsm/gsm.component';
import { SettingComponent } from './vehicles/components/setting/setting.component';
import { TagComponent } from './vehicles/components/tag/tag.component';
import { FollowComponent } from './vehicles/components/follow/follow.component';
import { VehicleHeaderComponent } from './vehicles/components/vehicle-header/vehicle-header.component';
import { PanelHistorialGraficoComponent } from './historial/components/panel-historial-grafico/panel-historial-grafico.component';

import { AlertModule } from './alerts/alert.module';
import { CommonModule } from '@angular/common';
import { PanelAlertsComponent } from './alerts/components/panel-alerts/panel-alerts.component';
import { TreeTableComponent } from './vehicles/components/tree-table/tree-table.component';
import { VehicleConfigComponent } from './vehicles/components/vehicle-config/vehicle-config.component';
import { GeocercaAddComponent } from './geofences/components/geocerca-add/geocerca-add.component';
import { GeocercaListsComponent } from './geofences/components/geocerca-lists/geocerca-lists.component';
import { GeocercaMainComponent } from './geofences/components/geocerca-main/geocerca-main.component';
import { VehicleGroupComponent } from './vehicles/components/vehicle-group/vehicle-group.component';
import { ReportComponent } from './reports/components/report/report.component';
import { FormComponent } from './reports/components/form/form.component';
import { ResultComponent } from './reports/components/result/result.component';
import { EventBoardComponent } from './events/components/event-board/event-board.component';
import { EventListComponent } from './events/components/event-list/event-list.component';
import { AddGeopointsComponent } from './geopoints/components/add-geopoints/add-geopoints.component';
import { ListGeopointsComponent } from './geopoints/components/list-geopoints/list-geopoints.component';

import { DataTablesModule } from 'angular-datatables';
import { ModalComponent } from './reports/components/modal/modal.component';
import { UserConfigComponent } from './profile-config/user-config/user-config.component';
import { UserInfoComponent } from './profile-config/user-info/user-info.component';

import { NgxChartsModule } from '@swimlane/ngx-charts';
import { AuditComponent } from './auditoria/components/audit/audit.component';
import { AuditformComponent } from './auditoria/components/auditform/auditform.component';
import { AuditresultComponent } from './auditoria/components/auditresult/auditresult.component';

import { SubcuentasComponent } from './subcuentas/subcuentas.component';
import { SubcuentasListComponent } from './subcuentas/components/subcuentas-list/subcuentas-list.component';
import { SubcuentasPanelComponent } from './subcuentas/components/subcuentas-panel/subcuentas-panel.component';
import { SubcuentasModalComponent } from './subcuentas/components/subcuentas-modal/subcuentas-modal.component';
import { AuditdetailComponent } from './auditoria/components/auditdetail/auditdetail.component';
import { AuditmapComponent } from './auditoria/components/auditmap/auditmap.component';
import { AuditInfoActivityComponent } from './auditoria/components/auditdetail/audit-info-activity/audit-info-activity.component';
import { NotFoundComponent } from './panel/not-found/not-found.component';
import { GeocercaCircularMainComponent } from './geofences/components/geocerca-circular-main/geocerca-circular-main.component';
import { GeocercaCircularAddComponent } from './geofences/components/geocerca-circular-add/geocerca-circular-add.component';
import { GeocercaCircularListsComponent } from './geofences/components/geocerca-circular-lists/geocerca-circular-lists.component';
import { GeocercaPolylineMainComponent } from './geofences/components/geocerca-polyline-main/geocerca-polyline-main.component';
import { GeocercaPolylineAddComponent } from './geofences/components/geocerca-polyline-add/geocerca-polyline-add.component';
import { GeocercaPolylineListsComponent } from './geofences/components/geocerca-polyline-lists/geocerca-polyline-lists.component';
import { DriversListComponent } from './drivers/components/drivers-list/drivers-list.component';
import { DriversPanelComponent } from './drivers/components/drivers-panel/drivers-panel.component';
import { DriversModalComponent } from './drivers/components/drivers-modal/drivers-modal.component';
import { GridComponent } from './multiview/grid/grid.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { DialogComponent } from './multiview/dialog/dialog.component';
import { DragItemComponent } from './multiview/drag-item/drag-item.component';
import { PreviewComponent } from './multiview/preview/preview.component';
import { ScreenViewComponent } from './multiview/screen-view/screen-view.component';
import { MinimapComponent } from './multiview/minimap/minimap.component';
import { PanelHistorialRecorridoModalComponent } from './historial/components/panel-historial-recorrido-modal/panel-historial-recorrido-modal.component';
import { GeofenceTableComponent } from './geofences/components/geofence-table/geofence-table.component';
import { AlphaNumericDashDirective } from './directives/alpha-numeric-dash.directive';
import { ScreenRecorderComponent } from './multiview/screen-recorder/screen-recorder.component';
import { CipiaComponent } from './cipia/cipia.component';
import { FootbarComponent } from './panel/components/footbar/footbar.component';
import { EventPopupComponent } from './events/components/event-popup/event-popup.component';
import { CarouselComponent } from './shared/components/carousel/carousel.component';
import { SliderMultimediaComponent } from './shared/components/slider-multimedia/slider-multimedia.component';
import { ShortenPipe } from './core/pipes/shorten.pipe';
import { AddTagComponent } from './geofences/components/add-tag/add-tag.component';
import { UnixTimeToDatePipe } from './core/pipes/unix-time-to-date.pipe';
import { ToastModule } from 'primeng-lts/toast';
import { AccordionModule } from 'primeng-lts/accordion';
import { TagImeiComponent } from './vehicles/components/tag-imei/tag-imei.component';
import { HasPermissionDirective } from './permiss/has-permission.directive';
import { EventEvaluationComponent } from './events/components/event-evaluation/event-evaluation.component';
import { ModalReportesProgramadosComponent } from './reports/components/modal-reportes-programados/modal-reportes-programados.component';
import { GeofencesModalComponent } from './geofences/components/geofences-modal/geofences-modal.component';
import { ButtonModule } from 'primeng-lts/button';
import { FileUploadModule } from 'primeng-lts/fileupload';
import { ModalGeoDetComponent } from './geofences/components/modal-geo-det/modal-geo-det.component';
import { GeofenceExportComponent } from './geofences/components/geofence-export/geofence-export.component';
import { DriversProgramacionModalComponent } from './drivers/components/drivers-programacion-modal/drivers-programacion-modal.component';
import { DriversProgramacionImportarComponent } from './drivers/components/drivers-programacion-importar/drivers-programacion-importar.component';
import { DriversProgramacionAgregarComponent } from './drivers/components/drivers-programacion-agregar/drivers-programacion-agregar.component';
import { DriversProgramacionListarComponent } from './drivers/components/drivers-programacion-listar/drivers-programacion-listar.component';
import { LogoutComponent } from './logout/logout.component';

import {
  ConnectionServiceModule,
  ConnectionServiceOptions,
  ConnectionServiceOptionsToken,
} from 'ngx-connection-service';
import { GeocercaDirectionComponent } from './geofences/components/geocerca-direction/geocerca-direction.component';
import { RpMainComponent } from './rep-programados/components/rp-main/rp-main.component';
import { RpListComponent } from './rep-programados/components/rp-list/rp-list.component';
import { RpAddComponent } from './rep-programados/components/rp-add/rp-add.component';
import { RpShowComponent } from './rep-programados/components/rp-show/rp-show.component';

import { DriversProgrammingAddComponent } from './drivers/components/drivers-programming-add/drivers-programming-add.component';
import { DriversProgrammingListComponent } from './drivers/components/drivers-programming-list/drivers-programming-list.component';
import { DriversProgrammingModalComponent } from './drivers/components/drivers-programming-modal/drivers-programming-modal.component';
import { DriverEnrollmentModalComponent } from './drivers/components/driver-enrollment-modal/driver-enrollment-modal.component';
import { TriStateCheckboxModule } from 'primeng-lts/tristatecheckbox';
import { DvrGalleryComponent } from './events/components/dvr-gallery/dvr-gallery.component';
import { UnixTimeToDate24Pipe } from './core/pipes/unix-time-to-date-24.pipe';
import { ActionsVehiclesComponent } from './vehicles/components/actions-vehicles/actions-vehicles.component';
import { VehicleFollowLinkComponent } from './vehicles/components/vehicle-follow-link/vehicle-follow-link.component';
import { FollowMainComponent } from './follow-link/components/follow-main/follow-main.component';
import { ChartsComponent } from './dashboard/components/charts/charts.component';
import { ChartComponent } from './dashboard/components/chart/chart.component';
import { ChartsTransmissionStatesComponent } from './dashboard/components/charts-transmission-states/charts-transmission-states.component';
import { UnitListComponent } from './dashboard/components/unit-list/unit-list.component';
import { ChartsDescriptiveStatisticsComponent } from './dashboard/components/charts-descriptive-statistics/charts-descriptive-statistics.component';
import { ContentPanelVehiclesComponent } from './vehicles/components/content-panel-vehicles/content-panel-vehicles.component';
import { CardVehicleComponent } from './vehicles/components/content-panel-vehicles/components/card-vehicle/card-vehicle.component';
import { ToolbarComponent } from './vehicles/components/content-panel-vehicles/components/toolbar/toolbar.component';
import { TabsVehicleComponent } from './vehicles/components/content-panel-vehicles/components/tabs-vehicle/tabs-vehicle.component';
import { LabelVehicleComponent } from './vehicles/components/content-panel-vehicles/components/label-vehicle/label-vehicle.component';
import { SummaryDetailsVehicleComponent } from './vehicles/components/content-panel-vehicles/components/summary-details-vehicle/summary-details-vehicle.component';
import { SquareButtonVehicleComponent } from './vehicles/components/content-panel-vehicles/components/square-button-vehicle/square-button-vehicle.component';
import { CheckboxVehicleComponent } from './vehicles/components/content-panel-vehicles/components/checkbox-vehicle/checkbox-vehicle.component';
import { VehicleCollectionComponent } from './vehicles/components/content-panel-vehicles/components/vehicle-collection/vehicle-collection.component';
import { LazyRenderDirective } from './vehicles/components/content-panel-vehicles/directive/lazy-render.directive';
import { DetailVehicleComponent } from './vehicles/components/content-panel-vehicles/components/detail-vehicle/detail-vehicle.component';
import { ItemCustomPanelVehicleComponent } from './vehicles/components/content-panel-vehicles/components/item-custom-panel-vehicle/item-custom-panel-vehicle.component';
import { SkeletonCollectionVehicleComponent } from './vehicles/components/content-panel-vehicles/components/skeleton-collection-vehicle/skeleton-collection-vehicle.component';
import { SkeletonCardVehicleComponent } from './vehicles/components/content-panel-vehicles/components/skeleton-card-vehicle/skeleton-card-vehicle.component';
import { TooltipForFooterCardComponent } from './vehicles/components/content-panel-vehicles/components/tooltip-for-footer-card/tooltip-for-footer-card.component';
import { ButtonToggleContainerComponent } from './vehicles/components/content-panel-vehicles/components/button-toggle-container/button-toggle-container.component';
import { ButtonToggleVehicleComponent } from './vehicles/components/content-panel-vehicles/components/button-toggle-vehicle/button-toggle-vehicle.component';
import { IconTransmissionStateComponent } from './vehicles/components/content-panel-vehicles/components/icon-transmission-state/icon-transmission-state.component';
import { DividerVehicleComponent } from './vehicles/components/content-panel-vehicles/components/divider-vehicle/divider-vehicle.component';
import { SkeletonButtonToggleContainerComponent } from './vehicles/components/content-panel-vehicles/components/skeleton-button-toggle-container/skeleton-button-toggle-container.component';
import { SkeletonButtonToggleVehicleComponent } from './vehicles/components/content-panel-vehicles/components/skeleton-button-toggle-vehicle/skeleton-button-toggle-vehicle.component';
import { SkeletonCheckboxVehicleComponent } from './vehicles/components/content-panel-vehicles/components/skeleton-checkbox-vehicle/skeleton-checkbox-vehicle.component';
import { SkeletonToolbarComponent } from './vehicles/components/content-panel-vehicles/components/skeleton-toolbar/skeleton-toolbar.component';
import { SkeletonContentPanelVehicleComponent } from './vehicles/components/content-panel-vehicles/components/skeleton-content-panel-vehicle/skeleton-content-panel-vehicle.component';
import { MapAsideComponent } from './panel/components/map-aside/map-aside.component';
import { UserConfigContainerComponent } from './profile-config/user-config/user-config-container/user-config-container.component';
import { UserIconsConfigComponent } from './profile-config/user-config/components/user-icons-config/user-icons-config.component';
import { UserPasswordUpdateComponent } from './profile-config/user-config/components/user-password-update/user-password-update.component';
import { UserProfileInfoComponent } from './profile-config/user-config/components/user-profile-info/user-profile-info.component';
import { UserPlatformInfoComponent } from './profile-config/user-config/components/user-platform-info/user-platform-info.component';
import { CheckboxContainerVehicleComponent } from './vehicles/components/content-panel-vehicles/components/checkbox-container-vehicle/checkbox-container-vehicle.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { BgLoadingContentPanelComponent } from './vehicles/components/content-panel-vehicles/components/bg-loading-content-panel/bg-loading-content-panel.component';
import { EventsContentComponent } from './panel/components/map-aside/components/events-content/events-content.component';
import { NotFoundContentComponent } from './panel/components/map-aside/components/not-found-content/not-found-content.component';
import { CardEventContentComponent } from './panel/components/map-aside/components/events-content/components/card-event-content/card-event-content.component';
import { ItemEventContentComponent } from './panel/components/map-aside/components/events-content/components/item-event-content/item-event-content.component';
import { UserThemeConfigComponent } from './profile-config/user-config/components/user-theme-config/user-theme-config.component';
import { UserPanelVisibilityComponent } from './profile-config/user-config/components/user-panel-visibility/user-panel-visibility.component';
import { VideoCustomComponent } from './shared/components/video-custom/video-custom.component';
import { MapsSliderComponent } from './multiview/screen-view/maps-slider/maps-slider.component';

import { ReportCsvComponent } from './reports/components/report-csv/report-csv.component';
import { UserLenguageConfigComponent } from './profile-config/user-config/components/user-lenguage-config/user-lenguage-config.component';

// import ngx-translate and the http loader
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AlertsListComponent } from './alertas/components/alerts-list/alerts-list.component';
import { AlertFormComponent } from './alertas/components/alert-form/alert-form.component';
import { ActivityInfoComponent } from './auditoria/components/auditdetail/activity-info/activity-info.component';
import { VehicleHistoryDrawerComponent } from './historial/components/vehicle-history-drawer/vehicle-history-drawer.component';
import { ContentVehicleHistoryDrawerComponent } from './historial/components/content-vehicle-history-drawer/content-vehicle-history-drawer.component';
import { HistoryCardComponent } from './historial/components/content-vehicle-history-drawer/components/history-card/history-card.component';
import { LoadingHistoryComponent } from './historial/components/content-vehicle-history-drawer/components/loading-history/loading-history.component';
import { ErrorHistoryComponent } from './historial/components/content-vehicle-history-drawer/components/error-history/error-history.component';
import { AsideHistoryCardComponent } from './historial/components/content-vehicle-history-drawer/components/aside-history-card/aside-history-card.component';
import { ToastHistoryInMapComponent } from './historial/components/content-vehicle-history-drawer/components/toast-history-in-map/toast-history-in-map.component';
import { StopsHistoryListComponent } from './historial/components/content-vehicle-history-drawer/components/stops-history-list/stops-history-list.component';
import { FramesHistoryListComponent } from './historial/components/content-vehicle-history-drawer/components/frames-history-list/frames-history-list.component';
import { EventsHistoryListComponent } from './historial/components/content-vehicle-history-drawer/components/events-history-list/events-history-list.component';
import { DashboardHistoryComponent } from './historial/components/content-vehicle-history-drawer/components/dashboard-history/dashboard-history.component';
import { TechnicalParametersComponent } from './historial/components/content-vehicle-history-drawer/components/technical-parameters/technical-parameters.component';
import { LicenseComponent } from './license/license.component';
import { ToastComponent } from './license/components/toast/toast.component';
import { DialogLicenseComponent } from './license/components/dialog/dialog.component';
import { SecondsToDaysPipe } from './core/pipes/seconds-to-days.pipe';
import { SecondsToTimeDetailedPipe } from './core/pipes/seconds-to-time-detailed.pipe';
import { ReportViewerComponent } from './reports/components/report-viewer/report-viewer.component';
import { NewReportComponent } from './reports/components/new-report/new-report.component';
import { ReportTableComponent } from './reports/components/report-table/report-table.component';
import { ReportBasicComponent } from './reports/components/report-viewer/viewers/report-basic/report-basic.component';
import { ReportVehiclesComponent } from './reports/components/report-viewer/viewers/report-vehicles/report-vehicles.component';
import { ReportSummaryComponent } from './reports/components/report-summary/report-summary.component';
import { ReportEventsComponent } from './reports/components/report-viewer/viewers/report-events/report-events.component';
import { UserCardVehicleComponent } from './profile-config/user-config/components/user-card-vehicle/user-card-vehicle.component';
import { IconsMaterialComponent } from './core/icons-material/icons-material.component';
import { UserHistoryDrawerComponent } from './profile-config/user-config/components/user-history-drawer/user-history-drawer.component';
import { UserFootbarConfigComponent } from './profile-config/user-config/components/user-footbar-config/user-footbar-config.component';
import { UserVehicleConfigComponent } from './profile-config/user-config/components/user-vehicle-config/user-vehicle-config.component';
import { UserAlertConfigComponent } from './profile-config/user-config/components/user-alert-config/user-alert-config.component';
import { UserGeofencesConfigComponent } from './profile-config/user-config/components/user-geofences-config/user-geofences-config.component';
import { UserGeopointsConfigComponent } from './profile-config/user-config/components/user-geopoints-config/user-geopoints-config.component';
import { UserEventsConfigComponent } from './profile-config/user-config/components/user-events-config/user-events-config.component';
import { UserDriversConfigComponent } from './profile-config/user-config/components/user-drivers-config/user-drivers-config.component';
import { ConfigLineComponent } from './profile-config/components/config-line/config-line.component';
import { UserHistoryConfigComponent } from './profile-config/user-config/components/user-history-config/user-history-config.component';
import { DriverIdentificationPanelComponent } from './drivers/driver-identification/components/driver-identification-panel/driver-identification-panel.component';
import { DriverSelectionListComponent } from './drivers/driver-identification/components/driver-selection-list/driver-selection-list.component';
import { DriverSelectionItemComponent } from './drivers/driver-identification/components/driver-selection-item/driver-selection-item.component';
import { DriverFullscreenComponent } from './drivers/driver-identification/components/driver-fullscreen/driver-fullscreen.component';

import { FleetChecklistListViewComponent } from './validation/views/fleet-checklist-list-view/fleet-checklist-list-view.component';
import { FleetChecklistViewComponent } from './validation/views/fleet-checklist-view/fleet-checklist-view.component';
import { ValidationSectionHeaderComponent } from './validation/components/validation-section-header/validation-section-header.component';
import { FleetChecklistCardComponent } from './validation/components/fleet-checklist-card/fleet-checklist-card.component';
import { FleetChecklistBoardComponent } from './validation/components/fleet-checklist-board/fleet-checklist-board.component';
import { FleetChecklistCreateViewComponent } from './validation/views/fleet-checklist-create-view/fleet-checklist-create-view.component';
import { VehicleChecklistTableComponent } from './validation/components/vehicle-checklist-table/vehicle-checklist-table.component';
import { ChecklistEvidenceUploadViewComponent } from './validation/views/checklist-evidence-upload-view/checklist-evidence-upload-view.component';
import { ValidationVehicleAvailableComponent } from './validation/components/validation-vehicle-available/validation-vehicle-available.component';
import { ValidationVehicleSelectionComponent } from './validation/components/validation-vehicle-selection/validation-vehicle-selection.component';
import { FleetChecklistEditViewComponent } from './validation/views/fleet-checklist-edit-view/fleet-checklist-edit-view.component';
import { UploadProgramacionViewComponent } from './validation/views/upload-programacion-view/upload-programacion-view.component';
import { CommandPanelComponent } from './vehicles/components/command-panel/command-panel.component';
import { UnitFilterComponent } from './tools/unit-filter/unit-filter.component';


@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    SidebarComponent,
    MapareaComponent,
    PanelConfComponent,
    VehiclesComponent,
    VehicleComponent,
    SessionComponent,
    MapComponent,
    PanelHistorialComponent,
    PanelMonitoreoComponent,
    PanelGeopointsComponent,
    PanelVehiclesComponent,
    EyeHeaderComponent,
    LimitHeaderComponent,
    FollowHeaderComponent,
    TransmissionHeaderComponent,
    TagHeaderComponent,
    TagDriverComponent,
    TagDriverHeaderComponent,
    SettingHeaderComponent,
    EyeComponent,
    GpsHeaderComponent,
    GsmHeaderComponent,
    MapViewComponent,
    TransmissionComponent,
    GpsComponent,
    GsmComponent,
    SettingComponent,
    ShortenPipe,
    TagComponent,
    FollowComponent,
    VehicleHeaderComponent,
    PanelHistorialGraficoComponent,
    PanelAlertsComponent,
    TreeTableComponent,
    VehicleConfigComponent,
    DashboardComponent,
    GeocercaAddComponent,
    GridComponent,
    GeocercaListsComponent,
    GeocercaMainComponent,
    VehicleGroupComponent,
    ReportComponent,
    FormComponent,
    ResultComponent,
    EventBoardComponent,
    EventListComponent,
    AddGeopointsComponent,
    ListGeopointsComponent,
    ModalComponent,
    UserConfigComponent,
    UserInfoComponent,
    AuditComponent,
    AuditresultComponent,
    AuditformComponent,
    SubcuentasComponent,
    SubcuentasListComponent,
    SubcuentasPanelComponent,
    SubcuentasModalComponent,
    AuditformComponent,
    AuditresultComponent,
    AuditdetailComponent,
    AuditmapComponent,
    AuditInfoActivityComponent,
    NotFoundComponent,
    GeocercaCircularMainComponent,
    GeocercaCircularAddComponent,
    GeocercaCircularListsComponent,
    GeocercaPolylineMainComponent,
    GeocercaPolylineAddComponent,
    GeocercaPolylineListsComponent,
    DriversListComponent,
    DriversPanelComponent,
    DialogLicenseComponent,
    DriversModalComponent,
    DialogComponent,
    DragItemComponent,
    PreviewComponent,
    ScreenViewComponent,
    MinimapComponent,
    PanelHistorialRecorridoModalComponent,
    GeofenceTableComponent,
    AlphaNumericDashDirective,
    ScreenRecorderComponent,
    CipiaComponent,
    FootbarComponent,
    EventPopupComponent,
    CarouselComponent,
    SliderMultimediaComponent,
    AddTagComponent,
    UnixTimeToDatePipe,
    TagImeiComponent,
    EventEvaluationComponent,
    ModalReportesProgramadosComponent,
    GeofencesModalComponent,
    ModalGeoDetComponent,
    GeofenceExportComponent,
    DriversProgramacionModalComponent,
    DriversProgramacionImportarComponent,
    DriversProgramacionAgregarComponent,
    DriversProgramacionListarComponent,
    LogoutComponent,
    GeocercaDirectionComponent,
    RpMainComponent,
    RpListComponent,
    RpAddComponent,
    RpShowComponent,
    DriversProgrammingAddComponent,
    DriversProgrammingListComponent,
    DriversProgrammingModalComponent,
    DriverEnrollmentModalComponent,
    DvrGalleryComponent,
    UnixTimeToDate24Pipe,
    ActionsVehiclesComponent,
    VehicleFollowLinkComponent,
    FollowMainComponent,
    ChartsComponent,
    ChartComponent,
    ChartsTransmissionStatesComponent,
    UnitListComponent,
    ChartsDescriptiveStatisticsComponent,
    ContentPanelVehiclesComponent,
    CardVehicleComponent,
    ToolbarComponent,
    TabsVehicleComponent,
    LabelVehicleComponent,
    SummaryDetailsVehicleComponent,
    SquareButtonVehicleComponent,
    CheckboxVehicleComponent,
    VehicleCollectionComponent,
    LazyRenderDirective,
    DetailVehicleComponent,
    ItemCustomPanelVehicleComponent,
    SkeletonCollectionVehicleComponent,
    SkeletonCardVehicleComponent,
    TooltipForFooterCardComponent,
    ButtonToggleContainerComponent,
    ButtonToggleVehicleComponent,
    IconTransmissionStateComponent,
    DividerVehicleComponent,
    SkeletonButtonToggleContainerComponent,
    SkeletonButtonToggleVehicleComponent,
    SkeletonCheckboxVehicleComponent,
    SkeletonToolbarComponent,
    SkeletonContentPanelVehicleComponent,
    UserConfigContainerComponent,
    UserIconsConfigComponent,
    UserPasswordUpdateComponent,
    UserProfileInfoComponent,
    UserPlatformInfoComponent,
    MapAsideComponent,
    CheckboxContainerVehicleComponent,
    BgLoadingContentPanelComponent,
    EventsContentComponent,
    NotFoundContentComponent,
    CardEventContentComponent,
    ItemEventContentComponent,
    UserThemeConfigComponent,
    UserPanelVisibilityComponent,
    VideoCustomComponent,
    MapsSliderComponent,
    UserLenguageConfigComponent,
    // EventTableComponent,
    ReportCsvComponent,
    AlertsListComponent,
    AlertFormComponent,
    ActivityInfoComponent,
    VehicleHistoryDrawerComponent,
    ContentVehicleHistoryDrawerComponent,
    HistoryCardComponent,
    LoadingHistoryComponent,
    ErrorHistoryComponent,
    AsideHistoryCardComponent,
    ToastHistoryInMapComponent,
    StopsHistoryListComponent,
    FramesHistoryListComponent,
    EventsHistoryListComponent,
    DashboardHistoryComponent,
    TechnicalParametersComponent,
    LicenseComponent,
    ToastComponent,
    DialogLicenseComponent,
    SecondsToDaysPipe,
    SecondsToTimeDetailedPipe,
    ReportViewerComponent,
    NewReportComponent,
    ReportTableComponent,
    ReportBasicComponent,
    ReportVehiclesComponent,
    ReportSummaryComponent,
    ReportEventsComponent,
    UserCardVehicleComponent,
    IconsMaterialComponent,
    UserHistoryDrawerComponent,
    ActivityInfoComponent,
    UserFootbarConfigComponent,
    UserVehicleConfigComponent,
    UserAlertConfigComponent,
    UserGeofencesConfigComponent,
    UserGeopointsConfigComponent,
    UserEventsConfigComponent,
    UserDriversConfigComponent,
    ConfigLineComponent,
    ConfigLineComponent,
    UserHistoryConfigComponent,
    DriverIdentificationPanelComponent,
    DriverSelectionListComponent,
    DriverSelectionItemComponent,
    DriverFullscreenComponent,
    FleetChecklistListViewComponent,
    FleetChecklistViewComponent,
    ValidationSectionHeaderComponent,
    FleetChecklistCardComponent,
    FleetChecklistBoardComponent,
    FleetChecklistCreateViewComponent,
    VehicleChecklistTableComponent,
    ChecklistEvidenceUploadViewComponent,
    ValidationVehicleAvailableComponent,
    ValidationVehicleSelectionComponent,
    FleetChecklistEditViewComponent,
    UploadProgramacionViewComponent,
    CommandPanelComponent,
    UnitFilterComponent,
  ],
  imports: [
    ConnectionServiceModule,
    ToastrModule.forRoot({
      timeOut: 3000,
      progressBar: true,
      progressAnimation: 'increasing',
      positionClass: 'toast-bottom-right',
      maxOpened: 4,
      autoDismiss: true,
    }),
    ChartModule,
    SkeletonModule,
    TabViewModule,
    RouterModule,
    BrowserModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    DataTablesModule,
    CommonModule,
    NgxSpinnerModule,
    NgxsModule.forRoot([AuthState]),
    AlertModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    PanelModule,
    NgSelectModule,
    AutoCompleteModule,
    TreeTableModule,
    TreeModule,
    DropdownModule,
    DialogModule,
    RatingModule,
    ColorPickerModule,
    ScrollPanelModule,
    InputMaskModule,
    InputTextModule,
    InputSwitchModule,
    TableModule,
    NgbModule,
    SliderModule,
    ToggleButtonModule,
    InputNumberModule,
    ConfirmDialogModule,
    SelectButtonModule,
    RadioButtonModule,
    PickListModule,
    ListboxModule,
    CardModule,
    ProgressBarModule,
    BadgeModule,
    TriStateCheckboxModule,
    CheckboxModule,
    OverlayPanelModule,
    TagModule,
    TooltipModule,
    ToastModule,
    AccordionModule,
    MultiSelectModule,
    CalendarModule,
    SlideMenuModule,
    MenuModule,
    GalleriaModule,
    LeafletModule,
    LeafletMarkerClusterModule,
    SidebarModule,
    CarouselModule,
    ProgressSpinnerModule,
    ButtonModule,
    ContextMenuModule,
    FileUploadModule,
    NgxsStoragePluginModule.forRoot({
      key: [
        'auth.token',
        'auth.access_token',
        'auth.name',
        'auth.expires_in',
        'auth.refresh_token',
      ],
    }),
    BrowserAnimationsModule,
    AgGridModule.withComponents([
      EyeComponent,
      TagHeaderComponent,
      TagDriverComponent,
      TagDriverHeaderComponent,
      FollowHeaderComponent,
      EyeHeaderComponent,
      LimitHeaderComponent,
      TransmissionHeaderComponent,
      SettingHeaderComponent,
      VehicleComponent,
      GpsHeaderComponent,
      GsmHeaderComponent,
      SettingComponent,
      GpsComponent,
      GsmComponent,
      TagComponent,
      FollowComponent,
      VehicleHeaderComponent,
    ]),
    NgxChartsModule,
    SplitButtonModule,
    ScrollingModule,
  ],
  providers: [
    ConfirmationService,
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    // {
    //   provide: HTTP_INTERCEPTORS,
    //   useClass: AuthInterceptor,
    //   multi: true
    // }
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http);
}
